"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Loading", {
  enumerable: true,
  get: function () {
    return _Loading.Loading;
  }
});
var _Loading = require("./Loading");
//# sourceMappingURL=index.js.map